<script setup>
import {computed, defineProps} from "vue";
import Checkbox from "@/components/Checkbox/Checkbox.vue";
import RadioButton from "@/components/Checkbox/RadioButton.vue";

const props = defineProps({
  label: {
    type: String,
    default: () => ""
  },
  modelValue: {
    type: Boolean,
    default: false
  },
  isMultiple: {
    type: Boolean,
    default: true
  }
});

const emit = defineEmits(["update:modelValue"]);

const isSelectedLocal = computed({
  set(value) {
    emit("update:modelValue", value);
  },
  get() {
    return props.modelValue;
  }
});

</script>

<template>
  <li
    class="dropdown-list__item"
    :class="{'dropdown-list__item--select': isSelectedLocal}"
    @click="isSelectedLocal = !isSelectedLocal"
  >
    <Checkbox
      v-if="props.isMultiple"
      v-model="isSelectedLocal"
      :label="props.label"
      readonly
    />
    <RadioButton
      v-else
      v-model="isSelectedLocal"
      :label="props.label"
    />
  </li>
</template>

<style scoped lang="scss">

.dropdown-list__item {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 14px;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;

  &-label {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &--select {
    color: var(--text-text-on);

    :deep(.checkbox__label) {
      color: var(--text-text-on);
    }

    &:hover {
      background-color: var(--background-bg-active-hover);
    }
  }

  &:hover:not(&--select) {
    background-color: var(--background-bg-hover);

    :deep(.checkbox__input) {
      border-color: var(--icon-icon-on);
    }
  }
}

</style>